/**
 * Маппинг ролей пользователей на русские названия
 * @param role - роль пользователя из enum'а
 * @returns русское название роли
 */
export const getRoleLabel = (role: string): string => {
  if (role === null || role === undefined) {
    return 'Неизвестно';
  }
  switch (String(role).toUpperCase()) {
    case 'SUPER_ADMIN':
      return 'Суперадминистратор';
    case 'OWNER':
      return 'Владелец';
    case 'ADMIN':
      return 'Администратор';
    case 'RECRUITER':
      return 'Рекрутер';
    default:
      return String(role);
  }
};